/**
 * Error raised when Microsoft Entra ID (Azure AD) SSO is used without the
 * required environment-specific configuration (client id / tenant id).
 *
 * These values are injected at build time from GitHub environment variables
 * (VITE_AZUREAD_*). A missing value almost always means the build/deploy
 * pipeline for this environment was not given the app-registration ids.
 */
export class AuthConfigurationError extends Error {
  /** Names of the env vars that were missing. */
  readonly missing: readonly string[];

  constructor(missing: readonly string[]) {
    super(
      `Entra SSO is not configured: missing ${missing.join(", ")}. ` +
        "Set these build-time environment variables (injected from GitHub " +
        "environment variables for this environment).",
    );
    this.name = "AuthConfigurationError";
    this.missing = missing;
  }
}
